export default __webpack_public_path__ + "static/media/bg-stream.92f4d23e.png";